export default __webpack_public_path__ + "static/media/cz1.9ced2ff0.svg";